import React from "react";
import "./Contact.css";
import EmailIcon from "@material-ui/icons/Email";
import PhoneIcon from "@material-ui/icons/Phone";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import GitHubIcon from "@material-ui/icons/GitHub";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
function Contact() {
  return (
    <div className="contact" data-aos="fade-right">
      <h1>Contact</h1>
      <div className="contact__content">
        <h5>
          Wanna hire..? Wanna collab on a side project..? Need a website for a
          new business / startup..? Find me on any of the links below.
        </h5>
        <div className="contact__links">
          <EmailIcon />
          <p>yahiyakhan2217@gmail.com</p>
        </div>
        <div className="contact__links">
          <PhoneIcon />
          <p>9036103964</p>
        </div>
        <div className="contact__links">
          <WhatsAppIcon />
          <p>7899676497</p>
        </div>

        <div className="contact__icons">
          <a href="https://github.com/yhya38" style={{ color: "white" }}>
            <GitHubIcon className="social__icon" />
          </a>
          <a
            href="https://www.linkedin.com/in/yahiya-khan-153a81184"
            style={{ color: "white" }}
          >
            <LinkedInIcon className="social__icon" />
          </a>
          <a
            href="https://www.facebook.com/yahiya.khan.100046"
            style={{ color: "white" }}
          >
            <FacebookIcon className="social__icon" />
          </a>
          <a
            href="https://www.instagram.com/its_a_y.a.khan/"
            style={{ color: "white" }}
          >
            <InstagramIcon className="social__icon" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Contact;
